import React, { useEffect, useContext } from "react";
import { DatePicker } from "antd";
import { RESTAURANT, serviceTime } from "./restaurantConstants";
import AHPTimePicker from "../../components/Calendar/AHPTimePicker";
import { AppContext } from "../../context";
import { FIELD_WIDTH, FIELD_WIDTHS } from "../../config/layoutConfig";
import AHPSelect from "../../components/AHPSelect/AHPSelect";
import { useLocation } from "react-router";
import moment from "moment";
import ImmediateConfirmation from "../../components/ImmediateConfirmation/ImmediateConfirmation";
import { searchRestaurants } from "./searchRestaurants";

function RestaurantFilter({ setStores }) {
  const info = useContext(AppContext);
  const location = useLocation();

  const handleChange = (type, value) => {
    info.setRestaurant({
      ...info.restaurant,
      [type]: value,
    });
  };

  useEffect(() => {
    (async () => {
      let restaurants = await searchRestaurants(info);
      setStores(restaurants);
    })();
  }, [info.villages, info.name, info.restaurant, info.immediateConfirmation]);

  return (
    <div className="ahp-service-filter">
      <div>
        <div style={{ display: "inline", marginTop: 6 }}>
          {info.t("people")}:
        </div>
        <AHPSelect
          label={info.t("people")}
          type="restaurant"
          field="people"
          options={RESTAURANT.PEOPLE_OPTIONS}
          width={FIELD_WIDTHS.XS}
        />
      </div>
      <DatePicker
        disabledDate={(current) => current && current < moment()}
        placeholder="DATA"
        value={info.restaurant?.date}
        onChange={(value) => handleChange("date", value)}
        style={{ width: FIELD_WIDTH / 2 }}
        bordered={false}
        allowClear={false}
      />

      <AHPSelect
        label={info.t("service")}
        type="restaurant"
        field="service"
        options={RESTAURANT.SERVICE_OPTIONS.map((opt) => ({
          value: opt,
          label: info.t(opt),
        }))}
        disabled={!info.restaurant?.date}
      />

      <AHPTimePicker
        availableTime={
          info.restaurant?.service
            ? serviceTime.find((s) => s.name === info.restaurant?.service)
                .availableTime
            : null
        }
        timeValue={info.restaurant?.time}
        disabled={!info.restaurant?.service}
        placeholder={info.t("time")}
        type="restaurant"
      />
      <ImmediateConfirmation />
    </div>
  );
}

export default RestaurantFilter;
